/**
 * Scope chooser for EDITING a recurring event.
 *
 * Asked AFTER the user saves, not before they edit — matching Google Calendar,
 * and for a practical reason: at the point of opening the form nobody knows yet
 * which fields they will touch, so a question asked then is guesswork.
 *
 * Before this existed the edit path sent a hardcoded `scope: 'all'` with no
 * prompt, so changing one occurrence rewrote the entire series. That is how a
 * weekly meeting moved wholesale when only one week was meant to shift.
 */

import { RecurringScopeDialog } from './RecurringScopeDialog';
import type { RecurrenceEditScope } from '../types';

interface EditRecurringEventDialogProps {
  open: boolean;
  title: string;
  onCancel: () => void;
  onConfirm: (scope: RecurrenceEditScope) => void;
}

export function EditRecurringEventDialog({
  open,
  title,
  onCancel,
  onConfirm,
}: EditRecurringEventDialogProps) {
  return (
    <RecurringScopeDialog
      open={open}
      heading="Edit recurring event"
      title={title}
      legend="Which events should be changed?"
      name="edit-scope"
      confirmLabel="Save"
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
}
